import * as React from "react";

export const colors = ['#6271FF', "#14AAFE", '#25D2AB', "#CDB6F2", '#FF5050', "#F57C37", "#1E9469"]

